var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationsReceived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9679 12.7568L25 8.68754L23.8591 7.53601L20.9679 10.454L19.2264 8.69623L18.0854 9.84776L20.9679 12.7568Z",
    fill: "url(#paint0_linear_13_1740)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7358 12.8045C23.1879 13.7794 23.4412 14.8665 23.4412 16.0123C23.4412 17.8784 22.7702 19.5892 21.6597 20.9127C21.2417 19.1406 20.0371 17.6729 18.4401 16.9079C19.0871 16.2553 19.4879 15.3539 19.4879 14.36C19.4879 12.3728 17.8861 10.7561 15.9172 10.7561C13.9484 10.7561 12.3465 12.3728 12.3465 14.36C12.3465 15.3539 12.7473 16.2551 13.3942 16.9077C11.7974 17.6729 10.5928 19.1406 10.1747 20.9127C9.06403 19.5892 8.39324 17.8784 8.39324 16.0123C8.39324 11.8251 11.7684 8.41847 15.9172 8.41847C16.4653 8.41847 17 8.47869 17.5153 8.59149L18.6537 7.4425C17.7808 7.15966 16.8603 7 15.9172 7C13.5354 7 11.2959 7.94841 9.6117 9.64824C7.9275 11.3483 7 13.6083 7 16.0123C7 18.4163 7.9275 20.6763 9.6117 22.3761C11.2959 24.076 13.5354 25 15.9172 25C18.2991 25 20.5383 24.076 22.2225 22.3761C23.9067 20.6763 24.8345 18.4163 24.8345 16.0123C24.8345 14.5012 24.4677 13.0471 23.7771 11.7533L22.7358 12.8045ZM13.9599 14.36C13.9599 13.2708 14.8381 12.3845 15.9172 12.3845C16.9964 12.3845 17.8745 13.2708 17.8745 14.36C17.8745 15.4491 16.9966 16.3354 15.9172 16.3354C14.8381 16.3354 13.9599 15.4491 13.9599 14.36ZM11.6291 22.2483C11.653 19.8816 13.5669 17.9638 15.9172 17.9638C18.2676 17.9638 20.1816 19.8816 20.2056 22.2483C18.9882 23.1036 17.5098 23.6061 15.9172 23.6061C14.3248 23.6061 12.8465 23.1036 11.6291 22.2483Z",
    fill: "url(#paint1_linear_13_1740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_1740",
    x1: 21.5427,
    y1: 7.53601,
    x2: 21.5427,
    y2: 12.7568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9496FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1740",
    x1: 15.9172,
    y1: 7,
    x2: 15.9172,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9496FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5DD7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsReceived);
export default __webpack_public_path__ + "static/media/applicationsReceived.92a0f7a21b4c393e21980bc83f686f18.svg";
export { ForwardRef as ReactComponent };